import { Card, CardBody, Col, Form, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { EmiBankSelect, NetBankings, Submit } from "../../../Constant";
import FormGroupCommon from "./Common/FormGroupCommon";
import { Btn } from "../../../AbstractElements";
import SelectCommon from "./Common/SelectCommon";

const NetBanking = () => {
  return (
    <Col xl="4" lg="6" className="box-col-33">
      <Card>
        <CommonCardHeader title={NetBankings} />
        <CardBody>
          <Form className="theme-form" onSubmit={(e) => e.preventDefault()}>
            <Row>
              <FormGroupCommon type="text" placeholder="AC Holder name" formClass="col-12" />
              <FormGroupCommon type="text" placeholder="Account number" formClass="col-12" />
              <SelectCommon size={1} data={EmiBankSelect} selectClass="col-6 p-r-0" />
              <FormGroupCommon type="text" placeholder="ICFC code" formClass="col-6" />
              <FormGroupCommon type="number" placeholder="Enter mobile number" formClass="col-12" />
              <FormGroupCommon type="text" placeholder="Other Details" formClass="col-12" />
              <Col xs="12">
                <Btn color="primary" className="btn-block">{Submit}</Btn>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default NetBanking;
